import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import AbonnementsRender from "./abonnement";
import Title from "../title";
import Footer from "../footer";
import PageTitle from "../theme/components/pagetitle";
import Loader from "../loader";
import {t} from "@lingui/core/macro"

export default class Abonnements extends Component{
    render(){
        if(this.props.loading){
            return (
                <div>
                    <Loader/>
                </div>
            )
        }

        const context=this.props.context
        const {org,config}=context
        const title=t`Abonnements de ${org.name}`
        const description=t`Abonnements de ${org.name}`

        return(
            <div>
                <Meta context={context} title={title} description={description}/>
                <Header context={context}/>
                <PageTitle context={context} title={t`Abonnements`} color="#845EC2"/>
                <div className="container" style={{marginTop:20,minHeight:"50vh"}}>
                    <AbonnementsRender context={context}/>
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}
